export default{
    load_category:"http://apps.codebetter.in:8082/quickserve/item/listAll",
    add_category:"http://apps.codebetter.in:8082/quickserve/item/save",
    load_brand:"http://apps.codebetter.in:8082/quickserve/serviceType/list",
    add_brand:"http://apps.codebetter.in:8082/quickserve/serviceType/save",
    load_product:"http://apps.codebetter.in:8082/quickserve/user/list",
    add_product:"http://apps.codebetter.in:8082/quickserve/user/save"


}